import { UserModel } from '../../models/complex/user.model';

export class UserMasterModel {
    public constructor(public userMasterData: UserModel[]) {}
}
